import { createContext } from "react";

const OTPAuthContext = createContext();

export default OTPAuthContext;
